export function adjustmentDialogTitle(
  noteType: 'Credit' | 'Debit',
  side: 'buy' | 'sell',
  editing: boolean,
): string {
  const verb = editing ? 'Edit' : 'Create';
  const suffix = side === 'buy' ? 'Purchase Side' : 'Sales Side';
  return `${verb} ${noteType} Note — ${suffix}`;
}

export function adjustmentDialogDescription(editing: boolean): string {
  return editing
    ? 'Edit any field while the note is in Draft. Issuing locks the note.'
    : 'Pick a parent invoice on this side, then fill in the adjustment details.';
}
